import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");
  const [coops, setCoops] = useState([]);
  const [selectedCoop, setSelectedCoop] = useState("all");
  const [meta, setMeta] = useState({ egg_sizes: [], defects: [], breeds: [], application_types: [] });
  const { user } = useAuth();

  useEffect(() => {
    if (user?.role === "operator") {
      const ids = user.assigned_coop_ids || (user.coop_id ? [user.coop_id] : []);
      if (ids[0]) setSelectedCoop(ids[0]);
    }
  }, [user]);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  const loadCoops = useCallback(async () => {
    const { data } = await api.get("/coops");
    setCoops(data);
  }, []);

  useEffect(() => {
    loadCoops();
    api.get("/meta").then(({ data }) => setMeta(data));
  }, [loadCoops]);

  const coopName = (id) => coops.find((c) => c.id === id)?.name || "-";
  const assignedIds = user?.role === "operator" ? (user.assigned_coop_ids || (user.coop_id ? [user.coop_id] : [])) : null;
  const myCoops = assignedIds ? coops.filter((c) => assignedIds.includes(c.id)) : coops;

  return (
    <AppContext.Provider value={{ theme, toggleTheme, coops, myCoops, loadCoops, selectedCoop, setSelectedCoop, meta, coopName, user, isOperator: user?.role === "operator" }}>
      {children}
    </AppContext.Provider>
  );
}
